// import { FETCH_PRIOR_INSURANCE_CARRIERS_SUCCESS, FETCH_PRIOR_INSURANCE_CARRIERS_FAILURE } from '../actions/actionTypes';

const initialState = {
  priorInsuranceCarriers: [],
  error: null,
};

const priorInsuranceCarriersReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_PRIOR_INSURANCE_CARRIERS_SUCCESS':
       
        return {
        ...state,
        priorInsuranceCarriers: action.payload,
        error: null,
      };
    case 'FETCH_PRIOR_INSURANCE_CARRIERS_FAILURE':
        
        return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default priorInsuranceCarriersReducer;
